<section class="p-10 card">

  <div class="grid grid-cols-3">
    <span class="font-mono italic">Primary Color :</span>
    <div class="flex gap-2 col-span-2">
      @for (i of themeColors$ | async | keyvalue; track $index) {
        <div>
          <input type="radio" id="theme-{{i.key}}" name="theme" hidden (change)="seletPrimaryColor(i.key)" 
            [checked]="(selectedColor$ | async) === i.key">
          <label for="theme-{{i.key}}" class="w-16 h-16 rounded-md border flex tooltip"  [attr.data-tip]="i.key"
          [ngClass]="(selectedColor$ | async) === i.key ? 'ring-2 ring-offset-2 ring-primary-500' : ''"          
            [style.backgroundColor]="i.value[500]">
          </label>
        </div>
      }@empty {
          <div>Loading Colors</div>
      }
    </div>
  </div>
  <hr class="my-5">
  <div class="grid grid-cols-3">
    <span class="font-mono italic">Font Style :</span>
    <div class="col-span-2">
    <div class="flex gap-2">
      @for (i of fontStyle$ | async | keyvalue; track $index) {
        <div>
          <input type="radio" id="font-{{i.key}}" name="font" hidden (change)="selectFont(i.key)" 
            [checked]="(selectedFont$ | async) === i.key">
          <label for="font-{{i.key}}" class="p-5 rounded-md border flex items-center justify-center text-lg tooltip" 
            [ngClass]="(selectedFont$ | async) === i.key ? 'ring-2 ring-primary-500' : ''"
            [attr.data-tip]="i.key"
            [style.fontFamily]="i.value">
            Aa
          </label>
        </div>
      }@empty {
        <div>Loading Fonts...</div>
      }
      
    </div>
    <div class="p-5 mt-3 border rounded-lg" [style.fontFamily]="selectedFont$ | async">
      <h2 class="text-2xl font-semibold">Lorem ipsum dolor sit</h2>
      <p class=" text-base mt-2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci in ex, qui modi eaque doloremque molestias voluptas quis. Aliquam, culpa. Asperiores aliquid deserunt ad omnis sed reprehenderit similique beatae quibusdam.</p>
      <p class="  mt-2">1234567890</p>
      <p class="  mt-2">!&#64;#$%^&*()_+*/</p>
      <p class=" text-xs mt-2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci in ex, qui modi eaque doloremque molestias voluptas quis. Aliquam, culpa. Asperiores aliquid deserunt ad omnis sed reprehenderit similique beatae quibusdam.</p>
    </div>
  </div>
  </div>



</section>


